import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";
export default class NgnLineSpecsApi {
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  get(id: number) {
    return getData({
      uri: "n/internet/NgnLineSpecs",
      id,
      context: this.context,
    });
  }
}
